<template>
  <v-card id="card_map_thuraya" class="elevation-0 mt-0 rounded-0">
    <v-card
      id="title_map_thuraya"
      class="container_showonmap ma-3 elevation-0 rounded-0 mt-0 pb-3"
      style="border: solid 1px #e0e0e0"
    >
      <v-toolbar id="header_vessel_thuraya" color="#F7F7F7" elevation="0" dense>
        <v-toolbar-title style="font-size: 1.2em">{{
          showmapthuraya.vessel_pt
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          small
          class="elevation-0 rounded-0"
          icon
          @click="closeShowMapThuraya()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card
        class="flexposisi pa-3 rounded-0"
        height="fit-content"
        elevation="0"
        style="margin-top: 0"
      >
        <v-card
          style="border: solid 1px #e0e0e0"
          class="datacard rounded-0"
          color="#F7F7F7"
          elevation="0"
        >
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="pl-3">Thuraya Number</td>
                  <td>:&nbsp;+{{ showmapthuraya.number }}</td>
                </tr>
                <tr>
                  <td class="pl-3">Service Plan</td>
                  <td>:&nbsp;{{ showmapthuraya.rateplan }}</td>
                </tr>
                <tr v-if="showmapthuraya.pertamina_report">
                  <td class="pl-3">Pertamina Tracking</td>
                  <td>:&nbsp;Active</td>
                </tr>
                <tr>
                  <td class="pl-3">Latitude, Longtitude</td>
                  <td>
                    :&nbsp;{{ showmapthuraya.message.lat }},{{
                      showmapthuraya.message.lng
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-3">DMS</td>
                  <td>:&nbsp;{{ showmapthuraya.message.dms }}</td>
                </tr>
                <tr>
                  <td class="pl-3">Last Updated</td>
                  <td>:&nbsp;{{ showmapthuraya.message.lastUp }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider></v-divider>
          <v-toolbar color="#F7F7F7" dense class="elevation-0 rounded-0"
            >Vessel Images</v-toolbar
          >
          <v-divider></v-divider>
          <v-data-table
            v-if="showmapthuraya.images"
            :items="showmapthuraya.images"
            :items-per-page="4"
            class="elevation-0 rounded-0 image"
            hide-default-footer
            :page.sync="pageImage"
            @page-count="pageCountImage = $event"
          >
            <template v-slot:item="row">
              <tr>
                <td
                  style="
                    background-color: #ffff;
                    padding: 1em;
                    border-bottom: none;
                  "
                >
                  <img
                    @click="(imageOpen = true), (imageData = row.item[0])"
                    :src="row.item[0]"
                    style="
                      cursor: pointer;
                      width: 6em;
                      height: 6em;
                      object-fit: cover;
                    "
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-toolbar dense class="elevation-0 rounded-0" color="#F7F7F7">
            <p class="mt-3" style="font-size: 0.8em">
              Showing 1 to 4 of {{ showmapthuraya.images.length }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              dense
              color="primary"
              v-model="pageImage"
              :length="pageCountImage"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-card>

        <v-card
          style="border: solid 1px #e0e0e0"
          color="#F7F7F7"
          class="mapcard rounded-0"
          elevation="0"
        >
          <v-toolbar
            color="#F7F7F7"
            class="elevation-0 rounded-0"
            dense
            elevation="0"
          >
            <v-menu offset-y content-class="elevation-0 rounded-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="border: solid 1px #e0e0e0"
                  color="#ffff"
                  class="rounded-0 elevation-0"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-update</v-icon>
                  &nbsp;
                  <div v-if="!showmaptracking_thur">Loading...</div>
                  <div v-if="showmaptracking_thur">
                    {{ showmaptracking_thur.range.label }}
                  </div>
                  &nbsp;
                  <v-icon small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list style="border: solid 1px #e0e0e0">
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="
                      showondate(showmapthuraya.id, 'today'),
                        set_clickdate('today')
                    "
                    >Today</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="
                      showondate(showmapthuraya.id, '24'), set_clickdate('24')
                    "
                    >Last 24 Hour</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="
                      showondate(showmapthuraya.id, '7', set_clickdate('7'))
                    "
                    >Last 7 Day</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="
                      showondate(showmapthuraya.id, '30'), set_clickdate('30')
                    "
                    >Last 30 Day</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="
                      showondate(
                        showmapthuraya.id,
                        'lmonth',
                        set_clickdate('lmonth')
                      )
                    "
                    >Last Month</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="
                      (dateopen = true), (datepickerID = showmapthuraya.id)
                    "
                    >Costume Range</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              class="elevation-0 rounded-0"
              @click="rpmReport(showmapthuraya)"
              v-if="
                showmapthuraya.rpm && !user_allowed.allowed['hide iot list']
              "
              style="margin-left: 1em"
              x-small
              dark
              color="#38C172"
              ><v-icon x-small>mdi-speedometer</v-icon>RPM Report</v-btn
            >
            <div
              v-if="
                (showmapthuraya.iot.power && showmapthuraya.gpio) ||
                showmapthuraya.rpm
              "
              class="gpiostatus ml-2"
            >
              <v-icon small> mdi-lightning-bolt </v-icon>
              <p class="txtgpio">AC Power :</p>
              <v-chip
                outlined
                small
                v-if="showmapthuraya.iot.power"
                class="mt-4 rounded-0 elevation-0 ml-2"
                color="green"
                >PLUGGED</v-chip
              >
              <v-chip
                outlined
                small
                v-if="showmapthuraya.iot.power == false"
                class="mt-4 rounded-0 elevation-0 ml-2 blink"
                color="red"
                >UNPLUGGED</v-chip
              >
            </div>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="!showmaptracking_thur" style="width: 220px">
              <div class="loader-line"></div>
            </v-toolbar-title>
            <v-chip
              style="border: solid 1px #e0e0e0"
              class="elevation-0 rounded-0"
              color="#fff"
              v-if="showmaptracking_thur"
              label
            >
              <v-icon small>mdi-calendar</v-icon>&nbsp;{{
                showmaptracking_thur.range.actual
              }}</v-chip
            >
          </v-toolbar>
          <v-divider></v-divider>
         
          <v-container
            v-if="!showmaptracking_thur"
            id="map_sailink"
            fill-height
            fluid
            style="margin-top: 0; height: 33em; background-color: #aad3df"
          >
            <v-row align="center" justify="center">
              <v-col
                ><img
                  alt="Navplus logo"
                  width="100px"
                  :src="loadernavplus"
                  class="justify-center"
              /></v-col>
            </v-row>
          </v-container>
          <!-- <l-map
            id="mapcard_thuraya"
            v-if="!maptop_thur && !clickdate"
            
            style="height: 50vh"
            ref="map"
            zoom="6"
            :center="[-1.3948190722183351, 111.45491167894518]"
            :options="{
              minZoom: 3,
              zoomControl: false,
              doubleClickZoom: true,
            }"
          >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer
          ></l-map> -->
         
          <l-map
            id="mapcard_thuraya"
            @polylinemeasure:add="onCount"
            @fullscreenchange="triggerFullscreen"
            @polylinemeasure:remove="onCount"
            @polylinemeasure:toggle="handleToggle"
            @polylinemeasure:finish="handleFinish"
            v-if="showmaptracking_thur"
            style="height: 45em"
            ref="map"
            :zoom="showmaptracking_thur.maptop ? 6 : 4"
            :center="
              showmaptracking_thur.maptop
                ? [
                    parseFloat(showmaptracking_thur.maptop.lat),
                    parseFloat(showmaptracking_thur.maptop.lon),
                  ]
                : [0.3810441033104415, 118.29473758871244]
            "
            :options="{minZoom: 3, zoomControl: false, doubleClickZoom: true, scrollWheelZoom:false }"
          >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-control-zoom position="bottomright"></l-control-zoom>
            <l-control-fullscreen
              position="bottomright"
              :options="{ title: { false: 'Go big!', true: 'Be regular' } }"
            />
            <l-control-polyline-measure
              v-if="etaControl"
              :ref="'polylineMeasure'"
              :options="{
                showUnitControl: false,
                showClearControl: false,
                measureControlClasses: ['hideControl'],
                showBearings: true,
                unit: unit,
                clearMeasurementsOnStop: false,
              }"
              position="bottomright"
            />

            <v-rotated-marker
              v-if="showmaptracking_thur.maptop"
              :lat-lng="[
                parseFloat(showmaptracking_thur.maptop.lat),
                parseFloat(showmaptracking_thur.maptop.lon),
              ]"
              :rotationAngle="parseInt(showmaptracking_thur.maptop.rotation)"
            >
              <l-icon
                :icon-size="[40 / 4, 100 / 4]"
                :icon-anchor="[40 / 4 / 2, 100 / 4 / 2]"
                class-name="someExtraClass"
              >
                <svg
                  id="a"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 40 100"
                >
                  <path
                    :fill="showmaptracking_thur.maptop.fill"
                    stroke="#FFF"
                    stroke-width="10"
                    d="M37.93,32.68L20,0,2.07,32.68c-1.35,2.45-2.07,5.41-2.07,8.44v57.33c0-11.59,8.95-20.99,20-20.99s20,9.4,20,20.99V41.12c0-3.03-.72-5.98-2.07-8.44Z"
                  />
                </svg>
              </l-icon>
              <l-popup @ready="draw_Circle(),movingStart()">
                <table>
                  <tr>
                    <td><b>Latitude</b></td>
                    <td>:</td>
                    <td>
                      {{ showmaptracking_thur.maptop.lat }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Longitude</b></td>
                    <td>:</td>
                    <td>{{ showmaptracking_thur.maptop.lon }}</td>
                  </tr>
                  <tr>
                    <td><b>DMS</b></td>
                    <td>:</td>
                    <td>{{ showmaptracking_thur.maptop.dms }}</td>
                  </tr>
                  <tr>
                    <td><b>Speed</b></td>
                    <td>:</td>
                    <td>
                      {{ showmaptracking_thur.maptop.speed + "&nbsp;knots" }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Heading</b></td>
                    <td>:</td>
                    <td>
                      {{ showmaptracking_thur.maptop.rotation + "&deg;" }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Last Update</b></td>
                    <td>:</td>
                    <td>{{ showmaptracking_thur.maptop.lastUp }}</td>
                  </tr>
                </table>
              </l-popup>
            </v-rotated-marker>

            <l-moving-rotated-marker 
        
        ref="driveMarker"
       
        :lat-lng="driveLatLng"
    :rotationAngle="driveRotationAngle"
    :duration="3000"
    :icon="icon"
  />
            <l-control
              position="topleft"
              style="display: flex; justify-content: space-between"
            >
              <div>
                <v-btn
                v-if="!etaControl"
                  elevation="0"
                  class="rounded-0 pa-1"
                  height="31"
                  width="50"
                  dark
                  :color="etaControl ? '#95BADF' : 'primary'"
                  @click="etaControl ? console.log('Already Open') : openETA()"
                >
                  <v-icon small>mdi-map-marker-distance</v-icon>
                  &nbsp; ETA
                </v-btn>
              </div>
            </l-control>
            <l-control position="bottomleft" style="display: flex">
              <v-card
                class="elevation-0 rounded-0"
                v-show="etaControl"
                height="fit-content"
                width="400"
              >
                <v-toolbar
                  class="elevation-0 rounded-0"
                  dense
               
                  color="#f7f7f7"
                >
                  <v-btn
                    id="strDraw_btn"
                    class="elevation-0 rounded-0"
                    :color="drawon ? '#95BADF' : 'primary'"
                    small
                    dark
                    @click="startDraw()"
                    >START DRAW</v-btn
                  >
                  <v-btn
                    class="elevation-0 rounded-0 ml-1"
                    color="primary"
                    small
                    dark
                    @click="clearMeasure()"
                    >CLEAR</v-btn
                  >
                  <v-btn
                    class="elevation-0 rounded-0 ml-1"
                    color="primary"
                    small
                    dark
                    @click="onCount()"
                    >COUNT</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="elevation-0 rounded-0"
                    fab
                    x-small
                  
                    color="#f7f7f7"
                    @click="
                      (etaControl = false),
                        (drawon = false),
                        clearMeasure(),
                        (totalDistance = 0),
                        (ex25 = false),
                        closeETA(),
                        (showRoute = false)
                    "
                  >
                    <v-icon > mdi-close </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-toolbar
                  class="elevation-0 pa-0"
                  dense
                  color="#fff"
                  style="display: flex"
                >
                  <div style="margin-left: -1.5em; display: flex">
                    <v-checkbox
                      v-model="ex25"
                      label=""
                      class="mx-0"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                    <div
                      style="
                        font-size: 1.2em;
                        margin-left: -1em;
                        margin-top: 1.3em;
                      "
                    >
                      Start From Marker
                    </div>
                    <v-spacer style="width: 1em"></v-spacer>
                    <v-checkbox
                      v-model="showRoute"
                      label=""
                      color="primary"
                      value="red darken-3"
                      hide-details
                    ></v-checkbox>
                    <div
                      style="
                        font-size: 1.2em;
                        margin-left: -1em;
                        margin-top: 1.3em;
                      "
                    >
                      Show Route Detail
                    </div>
                  </div>
                </v-toolbar>
                <v-divider></v-divider>
                <div style="padding: 0.5em">
                  <v-list style="margin: auto">
                    <v-list-item>
                      <v-list-item-content style="text-align: left">
                        <table>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Total Distance</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                {{ etaMiles }}&nbsp;Nmi
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Duration</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                {{ etaDuration }}&nbsp;Hours
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td><h3 style="font-size: 1.2em">Speed</h3></td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                <input
                                  style="
                                    width: 11em;
                                    background-color: #d5e6f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: pointer;
                                  "
                                  v-model="etaSpeed"
                                  type="number"
                                  v-on:input="countETA()"
                                />&nbsp;Knots
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Depature</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                <input
                                  style="
                                    width: 11em;
                                    background-color: #d5e6f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: pointer;
                                  "
                                  type="datetime-local"
                                  id="departure-sailink"
                                  name="departure-form"
                                  v-on:input="countETA()"
                                />
                                <span id="depart-container"></span>&nbsp;WIB
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Arrival</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                <input
                                  style="
                                    width: 11em;
                                    background-color: #f7f7f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: auto;
                                  "
                                  type="text"
                                  readonly
                                  :value="etaArrival"
                                />&nbsp;WIB
                              </h3>
                            </td>
                          </tr>
                        </table>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>

                <span class="d-none" id="depart-input-container"></span>
              </v-card>
            </l-control>
            <l-control position="topright">
              <v-card
                width="300"
                class="elevation-0 rounded-0"
                max-height="800"
                style="overflow-y: auto; margin-left: 1em"
                v-show="showRoute"
              >
                <v-toolbar
                  class="elevation-0 rounded-0"
                  color="#f7f7f7"
                  dense
                  ><v-spacer
                    ><v-toolbar-title>Coordinates</v-toolbar-title></v-spacer
                  >
                </v-toolbar>
                <v-divider></v-divider>
                <v-data-table
                  v-if="!showRouteData"
                  :headers="headersRoute"
                  :items="showRouteEmpty"
                  :items-per-page="itemsPerPageCoordinate"
                  :page.sync="pageCoordinate"
                  hide-default-footer
                  class="elevation-0 routeTable"
                  @page-count="pageCountCoordinate = $event"
                  ><template v-slot:item="row">
                    <tr>
                      <td class="pa-0" style="white-space: nowrap;text-align:center">
                        {{ row.item.index }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap;text-align:center">
                        {{ row.item.lat }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap;text-align:center">
                        {{ row.item.br }}
                      </td>
                    </tr></template
                  ></v-data-table
                >
                <v-data-table
                  v-if="showRouteData"
                  :headers="headersRoute"
                  :items="showRouteData"
                  hide-default-footer
                  :page.sync="pageCoordinate"
                  :items-per-page="itemsPerPageCoordinate"
                  class="elevation-0 routeTable"
                  @page-count="pageCountCoordinate = $event"
                  ><template v-slot:item="row">
                    <tr>
                      <td class="pa-0" style="white-space: nowrap;text-align:center">
                        {{ row.item.index + 1 }}
                      </td>
                      <td class="pa-0" style="text-align:center">
                        {{ convertDMS(row.item.lat, row.item.lng).split("-")[0]
                        }}<br />
                        {{
                          convertDMS(row.item.lat, row.item.lng).split("-")[1]
                        }}
                      </td>
                      <td class="pa-0" style="text-align:center" v-if="brRouteData">
                        {{
                          brRouteData[row.item.index]._icon.childNodes[4]
                            .innerText
                        }}
                        &nbsp;/&nbsp;
                        {{
                          brRouteData[
                            row.item.index
                          ]._icon.childNodes[0].data.split(" ")[1]
                        }}
                      </td>
                      <td class="pa-0" style="text-align:center" v-else></td></tr></template
                ></v-data-table>
                <v-toolbar
                  v-if="showRouteData"
                  dense
                  class="elevation-0 rounded-0"
                  color="#F7F7F7"
                >
                  <p class="mt-3" style="font-size: 0.8em">
                    Showing 1 to {{ itemsPerPageCoordinate }} of
                    {{ showRouteData.length }} entries
                  </p>
                  <v-spacer></v-spacer>
                  <v-pagination
                    dense
                    color="primary"
                    v-model="pageCoordinate"
                    :length="pageCountCoordinate"
                    :total-visible="7"
                  ></v-pagination>
                </v-toolbar>
              
              </v-card>
            </l-control>
          </l-map>
          <v-divider></v-divider>
          <v-toolbar dense color="#F7F7F7" elevation="0">
            User Who Can See This Vessel
            <v-spacer style="width: 20%"></v-spacer>
            <v-text-field
            style="border: solid 1px #e0e0e0;"
              width="40"
              v-model="searchUserWhoThur"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"
            
            ></v-text-field>
          </v-toolbar>
          <v-divider></v-divider>
          <v-data-table
            :headers="headersUser"
            :items="vesselUsersThuraya"
            :items-per-page="4"
            class="elevation-0 rounded-0 dataTable"
            hide-default-footer
            hide-default-header
            :page.sync="pageUser"
            @page-count="pageCountUser = $event"
            :search="searchUserWhoThur"
            dense
          >
          <template v-slot:header>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
               #
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Name
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Email
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Role
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Last Login
              </th>
            
            </template>
            <template v-slot:item="row">
              <tr>
                <td class="pa-0" style="white-space: nowrap;text-align: center;">
                  {{ row.item.index + 1 }}
                </td>
                <td class="pa-0" style="white-space: nowrap;text-align: center;">
                  {{ row.item.name }}
                </td>
                <td class="pa-0" style="white-space: nowrap;text-align: center;">
                  {{ row.item.email }}
                </td>
                <td class="pa-0" style="white-space: nowrap;text-align: center;">
                  {{ row.item.role_name }}
                </td>
                <td class="pa-0" style="white-space: nowrap;text-align: center;">
                  {{ row.item.lastLogin }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-toolbar dense class="elevation-0 rounded-0" color="#F7F7F7">
            <p class="mt-3" style="font-size: 0.8em">
              Showing 1 to {{ itemsPerPage }} of
              {{ vesselUsersThuraya.length }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              color="primary"
              dense
              v-model="pageUser"
              :length="pageCountUser"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-card>
      </v-card>

      <v-card
        style="border: solid 1px #e0e0e0"
        class="datatabledetail elevation-0 rounded-0 ma-3 mb-0 mt-0"
      >
        <v-toolbar
          elevation="0"
          style="max-height: 70px"
          color="#F7F7F7"
          fixed
          dense
        >
          <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="border: solid 1px #e0e0e0"
                small
                class="rounded-0 pa-1 elevation-0 ma-0 mr-2"
                color="#ffff"
                v-bind="attrs"
                v-on="on"
              >
                {{ kFormatter(itemsPerPage)
                }}<v-icon small style="margin-left: 0.2em"
                  >mdi-unfold-more-horizontal</v-icon
                >
              </v-btn>
            </template>
            <v-list style="border: solid 1px #e0e0e0">
              <v-list-item @click="itemsPerPage = 10"
                ><v-list-item-title>10</v-list-item-title></v-list-item
              >
              <v-list-item @click="itemsPerPage = 25"
                ><v-list-item-title>25</v-list-item-title></v-list-item
              >
              <v-list-item @click="itemsPerPage = 50"
                ><v-list-item-title>50</v-list-item-title></v-list-item
              >
              <v-list-item @click="itemsPerPage = 100"
                ><v-list-item-title>100</v-list-item-title></v-list-item
              >
            </v-list>
          </v-menu>
          <v-btn
            color="primary"
            class="elevation-0 rounded-0"
            @click="createCSV()"
            small
            ><v-icon small>mdi-file-move</v-icon> &nbsp;Export CSV</v-btn
          >
          <v-btn
            color="primary"
            class="elevation-0 rounded-0 ml-3"
            @click="createPDF()"
            small
            ><v-icon small>mdi-file-move</v-icon> &nbsp;Export PDF</v-btn
          >

          <v-spacer style="width: 50%"></v-spacer>
          <v-text-field
            style="border: solid 1px #e0e0e0;"
              width="40"
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"
            
            ></v-text-field>
        
        </v-toolbar>
        <v-divider></v-divider>
        <v-layout v-resize="onResize" column style="">
          <v-container
            id="map_thuraya"
            v-if="!showmaptracking_thur"
            fill-height
            fluid
            style="height: 250px"
          >
            <v-row align="center" justify="center">
              <v-col
                ><img
                  alt="Navplus logo"
                  width="100px"
                  :src="loadernavplus"
                  class="justify-center"
              /></v-col>
            </v-row>
          </v-container>
          <v-data-table
            :search="search"
            style="margin-top: 0px"
            v-if="showmaptracking_thur && showmapthuraya.weather == null"
            :headers="headersData"
            :items="showmaptracking_thur.dataTable"
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 rounded-0 dataTable"
            @page-count="pageCount = $event"
          >
            <template v-slot:header>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                No
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Latitude, Longitude
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                DMS
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Altitude
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Speed<br />(Knots)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Heading<br />(Degree)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Distance<br />(Nmi)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                dateTime<br />(UTC)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                dateTime<br />(GMT+7)
              </th>
            </template>
            <template v-slot:item="row">
              <tr>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.index + 1 }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <a @click="triggerPopup(row.item)"
                    >{{ row.item.lat }} , {{ row.item.lng }}</a
                  >
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.dms }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.altitude }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.speed }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.heading }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.distance }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.dateTime }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.dateTime_local }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-data-table
            :search="search"
            style="margin-top: 0px"
            v-if="showmaptracking_thur && showmapthuraya.weather != null"
            :headers="headers"
            :items="showmaptracking_thur.dataTable"
            multi-sort
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 rounded-0 dataTable"
            @page-count="pageCount = $event"
            item-key="msg_id"
            :expanded.sync="expanded"
            :single-expand="singleExpand"
          >
            <template v-slot:header>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              ></th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                No
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Latitude, Longitude
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                DMS
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Altitude
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Speed<br />(Knots)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Heading<br />(Degree)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                Distance<br />(Nmi)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                dateTime<br />(UTC)
              </th>
              <th
                class="pa-0 pt-2 pl-1 pb-2"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                  text-align: center;
                "
              >
                dateTime<br />(GMT+7)
              </th>
            </template>
            <template v-slot:item="{ item, expand, isExpanded }">
              <tr>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <v-btn
                    x-small
                    class="mx-2 rounded-0 elevation-0"
                    fab
                    dark
                    color="primary"
                    @click="
                      !isExpanded
                        ? (weatherClick(
                            showmapthuraya.id,
                            item.msg_id,
                            'sailink',
                            item.dateTime
                          ),
                          expand(!isExpanded))
                        : (removeWeather(item.dateTime), expand(!isExpanded))
                    "
                  >
                    <v-icon dark>
                      {{ !isExpanded ? "mdi-plus" : "mdi-minus" }}
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.index + 1 }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <a @click="triggerPopup(item)"
                    >{{ item.lat }} , {{ item.lng }}</a
                  >
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.dms }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.altitude }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.speed }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.heading }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.distance }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.dateTime }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.dateTime_local }}
                </td>
              </tr>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="background-color: #b8cce2">
                <v-toolbar
                  class="elevation-0 text-center"
                  dense
                  color="#F7F7F7"
                  elevation="2"
                >
                  <v-spacer> Weather & Wave </v-spacer></v-toolbar
                >
                <v-progress-linear
                  v-if="!weatherData[item.dateTime]"
                  indeterminate
                  color="#0B4281"
                  height="7"
                  striped
                ></v-progress-linear>
                <v-row
                  v-if="weatherData[item.dateTime]"
                  no-gutters
                  style="flex-wrap: nowrap"
                >
                  <v-col
                    cols="1"
                    style="min-width: 100px; max-width: 100%; margin: 5px"
                    class="flex-grow-1 flex-shrink-0"
                  >
                    <v-card class="pa-2" outlined tile>
                      <v-card-text>
                        <v-simple-table>
                          <template v-slot:default>
                            <tr>
                              <td style="padding: 6px">Weather</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].weather }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Wind Direction</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].windDirection }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Wind Speed</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].windSpeed }}
                              </td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="1"
                    style="min-width: 100px; max-width: 100%; margin: 5px"
                    class="flex-grow-1 flex-shrink-0"
                  >
                    <v-card class="pa-2" outlined tile>
                      <v-card-text>
                        <v-simple-table>
                          <template v-slot:default>
                            <tr>
                              <td style="padding: 6px">Temperature</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].temperature }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Humidity</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].humidity }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Dew Point</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].dewPoint }}
                              </td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="1"
                    style="min-width: 100px; max-width: 100%; margin: 5px"
                    class="flex-grow-1 flex-shrink-0"
                  >
                    <v-card class="pa-2" outlined tile>
                      <v-card-text>
                        <v-simple-table>
                          <template v-slot:default>
                            <tr>
                              <td style="padding: 6px">Wave Height</td>
                              <td style="padding: 6px">
                                {{
                                  weatherData[item.dateTime]
                                    .waveSignificantHeight
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Wave From Direction</td>
                              <td style="padding: 6px">
                                {{
                                  weatherData[item.dateTime].waveFromDirection
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">
                                <p style="height: 2px"></p>
                              </td>
                              <td style="padding: 6px">
                                <p style="height: 2px"></p>
                              </td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>

          <v-toolbar v-if="showmaptracking_thur" dense class="elevation-0 rounded-0" color="#F7F7F7">
            <p class="mt-3" style="font-size: 0.8em">
              Showing 1 to {{ itemsPerPage }} of
              {{ showmaptracking_thur.dataTable.length }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              class="mt-2"
              color="primary"
              v-if="showmapthuraya"
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-layout>

        <div id="app">
          <v-app id="inspire"> </v-app>
        </div>
      </v-card>

      <!--Modal Image-->
      <v-dialog v-model="imageOpen">
        <!-- <v-carousel v-model="model" width="fit-content">
          <v-carousel-item
            @click="(imageOpen = true), (imageData = showmapthuraya.images)"
            v-for="image in showmapthuraya.images"
            :key="image"
          >
            <v-img :src="image[0]" ></v-img>
          </v-carousel-item>
        </v-carousel> -->
        <v-carousel hide-controls hide-delimiters>
          <v-carousel-item
            @click="imageOpen = false"
            v-for="(item, i) in showmapthuraya.images"
            :key="i"
          >
            <img style="height: 100%" :src="item[0]" />
          </v-carousel-item>
        </v-carousel>
      </v-dialog>
      <!--Modal Notif End-->

      <!--Modal Custom Range-->
      <v-dialog
        ref="dialog"
        v-model="dateopen"
        :return-value.sync="dates"
        class="elevation-0 rounded-0"
        persistent
        width="290px"
      >
        <v-date-picker
          color="#0B4281"
          class="elevation-0 rounded-0"
          v-model="dates"
          range
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dateopen = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="customRange()"> OK </v-btn>
        </v-date-picker>
      </v-dialog>
      <!--Modal Custom Range-->
    </v-card>
  </v-card>
</template>

<script>
import $ from "jquery";
import L from "leaflet";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  LPopup,
  LMap,
  LTileLayer,
  LIcon,
  LControl,
  LControlZoom,
} from "vue2-leaflet";
import Vue2LeafletRotatedMarker from "vue2-leaflet-rotatedmarker";
import LMovingRotatedMarker from 'vue2-leaflet-rotatedmarker'
import LControlFullscreen from "vue2-leaflet-fullscreen";
import LControlPolylineMeasure from "vue2-leaflet-polyline-measure";
import mapstyle from "@/assets/json/mapstyle.json";
import { mapSettingsShow } from "@/constants/mapSettings";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";


const iconUrl= 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDIuODggMy40NiI+PGRlZnM+PHN0eWxlPi5ke2ZpbGw6IzAwMDBGRjtzdHJva2U6I2ZmZjtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6LjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9ImEiLz48ZyBpZD0iYiI+PGcgaWQ9ImMiPjxwYXRoIGNsYXNzPSJkIiBkPSJNMi42OSwzLjI2bC0uOTYtLjQ1Yy0uMTktLjA5LS40LS4wOS0uNTksMGwtLjk2LC40NUwxLjQ0LC4yNmwxLjI1LDNaIi8+PC9nPjwvZz48L3N2Zz4='

export default {
  components: {
    LPopup,
    LIcon,
    LMap,
    LTileLayer,
    LControl,
    LControlPolylineMeasure,
    LControlFullscreen,
    LControlZoom,
    "v-rotated-marker": Vue2LeafletRotatedMarker,
    LMovingRotatedMarker
  },
  data() {
    return {
      countLength:0,
      IntervalMoving: null,
      fetchInterval:null,
      icon: L.icon({
                    iconUrl: iconUrl,
                    iconSize: [15,20],
                    iconAnchor: [7.5,10],
                    popupAnchor: [0,-25]
                }),
                 drivePath : null,
                 driveLatLng: null,
                 driveRotationAngle: null,
                driveMarker:null,
      searchUserWhoThur: "",
      user_allowed: JSON.parse(localStorage.getItem("user_data")),
      weatherData: [],
      headersRoute: [
        {
          text: "#",
          value: "index",
        },
        { text: "Latitude/Longitude", value: "Latitude" },
        { text: "Distance/Bearing", value: "Distance/Bearing" },
      ],
      itemsPerPageCoordinate: 10,
      pageCoordinate: 1,
      pageCountCoordinate: 0,
      showRoute: false,
      showRouteData: null,
      showRouteEmpty: [{ index: 0, lat: "-", lng: "-", br: "-" }],
      drawon: null,
      etaControl: null,
      etaArrival: "",
      etaDuration: 0,
      etaSpeed: 1,
      etaMiles: 0,
      url: "https://maps.skyreach.id/sailink/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      dateopen: false,
      datepickerID: null,
      pageUser: 1,
      pageCountUser: 0,
      dates: [],
      itemsPerPage: 10,
      page: 1,
      pageCount: 0,
      itemsPerPageImage: 10,
      pageImage: 1,
      pageCountImage: 0,
      loadernavplus: require("@/assets/img/load100new.gif"),
      headers: [
        {
          text: " ",
          align: "start",
        },
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Latitude, Longtitude ", value: "lat" },
        { text: "DMS", value: "dms" },
        { text: "Altitude", value: "altitude" },
        { text: "Speed (Knots)", value: "speed" },
        { text: "Heading (Degree)", value: "heading" },
        { text: "Distance(Nmi)", value: "distance" },
        { text: "dateTime (UTC)", value: "dateTime" },
        { text: "dateTime (GMT+7)", value: "dateTime_local" },
      ],
      headersData: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Latitude, Longtitude ", value: "lat" },
        { text: "DMS", value: "dms" },
        { text: "Altitude", value: "altitude" },
        { text: "Speed (Knots)", value: "speed" },
        { text: "Heading (Degree)", value: "heading" },
        { text: "Distance(Nmi)", value: "distance" },
        { text: "dateTime (UTC)", value: "dateTime" },
        { text: "dateTime (GMT+7)", value: "dateTime_local" },
      ],
      headersUser: [
        {
          text: "#",
          align: "start",
          sortable: false,
        },
        { text: "Name", value: "name", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Role", value: "role_name", sortable: false },
        { text: "Last Login", value: "lastLogin", sortable: false },
      ],
      options: {
        disableDefaultUI: true,
        fullscreenControl: true,
        zoomControl: true,
        styles: mapstyle,
      },
      imageOpen: null,
      imageData: null,
      msg_id_after: null,
      weather_data: null,
      search: "",
    };
  },

  mounted() {
    var userallow = localStorage.getItem("user_data");
    this.user_allowed = JSON.parse(userallow);

    var mama = this;

    this.initialdata_movingfirst()

    if (!mama.thuraya_executed) {
      console.log("DI SET KE TRUE OLEH MOUTED MAP");
      mama.addthuraya_executed(true);
      $("html, body").animate(
        {
          scrollTop: $("#title_map_thuraya").offset().top - 109,
        },
        800
      );
    }
  },

  methods: {
    ...mapActions([
      "unsetmaptracking_",
      "showonMapThuraya",
      "showdateThuraya",
      "removeShowThuraya",
      "inputRPMID",
      "inputSearchIOT",
      "set_clickdate",
      "addthuraya_executed",
    ]),


    initialdata_movingfirst(){
      var mother = this
  
            mother.drivePath = mother.showmaptracking_thur.tracking.slice()
    mother.driveLatLng= L.latLng([mother.drivePath[0].lat, mother.drivePath[0].lng])
    mother.driveRotationAngle= mother.drivePath[0].heading

 
    },

    initialdata_moving(){
      var mother = this
   
        
      if(mother.showmaptracking_thur){
        mother.drivePath = mother.showmaptracking_thur.tracking.slice()
    mother.driveLatLng= L.latLng([mother.drivePath[0].lat, mother.drivePath[0].lng])
    mother.driveRotationAngle= mother.drivePath[0].heading
    clearInterval(mother.fetchInterval);
    return
      }
       
     
          

   

 
    },


    movingStart(){
      var mother=this
      this.IntervalMoving = setInterval(function () {
            mother.simulate()
          }, 100);
     
    },

    simulate() {  
      
                this.countLength=this.countLength+1
                console.log(this.countLength)
                console.log(this.drivePath)
                console.log(this.showmaptracking_thur.tracking.length)
                if(this.drivePath.length>0){
                  
                if(!this.drivePath.length) {
                    this.$refs.driveMarker.mapObject.setLatLng(L.latLng([this.drivePath[0].lat, this.drivePath[0].lng]))
                    this.drivePath= this.drivePath.slice()
                    return
                }
                let point= this.drivePath.shift()
                this.driveLatLng= L.latLng([point.lat, point.lng])
                this.driveRotationAngle= point.heading
                console.log(this.driveRotationAngle)
                if(this.showmaptracking_thur.tracking)
               {
                if(this.countLength == this.showmaptracking_thur.tracking.length){
                  clearInterval(this.IntervalMoving);
                }
               }
               return
                }
            },

        triggerFullscreen(){
      if(this.$refs["map"].mapObject._isFullscreen != true){
        this.$refs.map.mapObject.scrollWheelZoom.disable();
      }else{
        this.$refs.map.mapObject.scrollWheelZoom.enable();
      }
    },

    convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }

        str += line + '\r\n';
    }

    return str;
},

download(){
  var itemsFormatted = [];
  var headers = {
      index:'#',
      latitude: 'latitude', // remove commas to avoid errors
      longitude: "Longitude",
      dms: "DMS",
      altitude: "Altitude",
      speed:"Speed (Knots)",
      heading:"Heading (Degree)",
      distance:"Distance (Nmi)",
      dateTime:"dateTime (GMT+7)"


  };

  var itemsNotFormatted = this.showmaptracking_thur.dataTable
 

  // format the data
  itemsNotFormatted.forEach((item) => {
      itemsFormatted.push({
        index:item.index+1,
      latitude: item.lat, // remove commas to avoid errors
      longitude:item.lng,
      dms: item.dms,
      altitude: item.altitude,
      speed:item.speed,
      heading:item.heading,
      distance:item.distance,
      dateTime:item.dateTime_local
      });
  });

  var fileTitle = 'orders'; // or 'my-unique-title'

  this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
},

exportCSVFile(headers, items, fileTitle) {
    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var csv = this.convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
},

    createCSV() {
      //console.log(this.showmaptable.vessel_pt);
      var parts = this.showmapthuraya.vessel_pt.split(" ");
      //console.log(parts);

      let pdfName = parts[0] + "_" + parts[1] + "_Tracking_Reports";

      var tableTracking = this.showmaptracking_thur.dataTable
      //console.log(tableTracking);






this.download()
    },


    createPDF() {
      //console.log(this.showmaptable.vessel_pt);
      var parts = this.showmapthuraya.vessel_pt.split(" ");
      //console.log(parts);

      let pdfName = parts[0] + "_" + parts[1] + "_Tracking_Reports";
      var doc = new jsPDF({
        orientation: "l",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
      });

      doc.setProperties({
        title: pdfName,
        subject: "Its a Subject",
        author: "Me!",
        creator: "My Company Name",
      });


     
      var result = this.showmaptracking_thur.dataTable
      //console.log(result);
      //console.log(this.tableTracking);

      let info = [];
      result.forEach((element) => {
        info.push([
          [element.index + 1],
          [element.lat, element.lng, `(` + element.dms + `)`],
          [element.dms],
          [element.altitude],
          [element.speed],
          [element.heading],
          [element.distance],
          [element.dateTime],
          [element.dateTime_local],
        ]);
      });

      //console.log(info);
      doc.text(this.showmapthuraya.vessel_pt, 15, 5);
      doc.text("Vessel Tracking Report", 15, 10, { fontSize: 9 });

      autoTable(doc, {
        head: [
          [
         "#",
       "latitude, longitude",
       "DMS",
       "Altitude",
       "Speed (Knots)",
       "Heading (Degree)",
       "Distance (Nmi)",
       "dateTime (UTC)",
       "dateTime (GMT+7)",
          ],
        ],
        body: info,
        theme: "striped",
      });

      doc.save(pdfName + ".pdf");
      // doc.output("dataurlnewwindow");
    },


    removeWeather(dateTime) {
      this.$delete(this.weatherData, dateTime);
    },

    closeShowMapThuraya() {
      clearInterval(this.IntervalMoving);
      this.removeShowThuraya();
      $("html, body").animate(
        {
          scrollTop: $("#top_mythuraya").offset().top - 140,
        },
        800
      );
    },

    centertoMap_() {
      console.log("centertomap_");
      $("html, body").animate(
        {
          scrollTop: $("#header_vessel_thuraya").offset().top,
        },
        1000
      );
    },

    triggerPopup(coord) {
      console.log(coord);
      $("html, body").animate(
        {
          scrollTop: $("#title_map_thuraya").offset().top - 109,
        },
        800
      );
      var myMap = this.$refs.map.mapObject;
      var popLocation = new L.LatLng(coord.lat, coord.lng);
      myMap.setView(popLocation, 6);
      var popup = L.popup()
        .setLatLng(popLocation)
        .setContent(
          "<table><tr><td><b>Latitude</b></td><td>:</td><td>" +
            coord.lat +
            "</td></tr><tr><td><b>Longitude</b></td><td>:</td><td>" +
            coord.lng +
            "</td></tr><tr>" +
            "<td><b>DMS</b></td><td>:</td>" +
            "<td>" +
            coord.dms +
            "</td>" +
            "</tr>" +
            "<tr>" +
            "<td><b>Speed</b></td>" +
            "<td>:</td>" +
            " <td>" +
            coord.speed +
            "&nbsp;knots </td>" +
            "</tr>" +
            "<tr>" +
            " <td><b>Heading</b></td>" +
            "<td>:</td>" +
            "<td>" +
            coord.heading +
            "</td>" +
            " </tr>" +
            "<tr>" +
            "<td><b>Last Update</b></td>" +
            "<td>:</td>" +
            "<td>" +
            coord.dateTime +
            "</td>" +
            "</tr>" +
            "</table>"
        )
        .openOn(myMap);
    },

    draw_Circle() {
      var myMap = this.$refs.map.mapObject;
      var mama = this;
      console.log("MAP OBJEK");
      console.log(myMap);
      var latLong = this.showmaptracking_thur.tracking;
      var pointList = this.showmaptracking_thur.tracking;

      var firstpolyline = new L.Polyline(pointList, {
        color: "#FEE800",
        weight: 4,
        opacity: 1,
        smoothFactor: 1,
      });
      firstpolyline.addTo(myMap);
      // Here's where you iterate over the array of coordinate objects.
      latLong.forEach(function (coord) {
        if (
          coord.lat != mama.showmaptracking_thur.maptop.lat &&
          coord.lng != mama.showmaptracking_thur.maptop.lon
        ) {
          var circle = L.circle(coord, {
            color: "#1DC01D",
            fillColor: "#1DC01D",
            fillOpacity: 0.5,
            radius: 1800,
          })
            .addTo(myMap)
            .bindPopup(
              "<table><tr><td><b>Latitude</b></td><td>:</td><td>" +
                coord.lat +
                "</td></tr><tr><td><b>Longitude</b></td><td>:</td><td>" +
                coord.lng +
                "}}</td></tr><tr>" +
                "<td><b>DMS</b></td><td>:</td>" +
                "<td>" +
                coord.dms +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Speed</b></td>" +
                "<td>:</td>" +
                " <td>" +
                coord.speed +
                "&nbsp;knots </td>" +
                "</tr>" +
                "<tr>" +
                " <td><b>Heading</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.heading +
                "</td>" +
                " </tr>" +
                "<tr>" +
                "<td><b>Last Update</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.updated +
                "</td>" +
                "</tr>" +
                "</table>"
            );
        }
      });
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    async weatherClick(id, msgid, type, dateTime) {
      // this.$delete(this.weatherData, dateTime);
      console.log(this.weatherData);

      const datawth = {
        id: id,
        msg_id: msgid,
        type: type,
      };
      const response = await axios.post(
        "https://navigatorplus.sailink.id/api/v1/navplus/weather/fetchRow",
        datawth,
        {
          headers: {
            Authorization: "Bearer" + localStorage.getItem("token"),
          },
        }
      );
      console.log(response);
      this.$set(this.weatherData, dateTime, response.data.data);
      console.log("weather datanya i fetch baru");
      console.log(this.weatherData);
    },

    toDegreesMinutesAndSeconds(coordinate, pad) {
      var absolute = Math.abs(coordinate);
      var degrees = Math.floor(absolute);
      var minutesNotTruncated = (absolute - degrees) * 60;
      var minutes = Math.floor(minutesNotTruncated);
      var seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      //eslint-disable-next-line
      return (
        String(degrees).padStart(pad, "0") +
        "°" +
        String(minutes).padStart(2, "0") +
        " ' " +
        String(seconds).padStart(2, "0") +
        '"'
      );
    },

    customRange() {
      this.dateopen = false;
      var range_date = this.dates.join(" ");
      console.log(range_date);
      this.set_clickdate("custom");
      this.showondate(this.datepickerID, range_date);
    },

    convertDMS(lat, lng) {
      var latitude = this.toDegreesMinutesAndSeconds(lat, 2);
      var latitudeCardinal = lat >= 0 ? "N" : "S";

      var longitude = this.toDegreesMinutesAndSeconds(lng, 3);
      var longitudeCardinal = lng >= 0 ? "E" : "W";

      return (
        latitude +
        " " +
        latitudeCardinal +
        "-" +
        longitude +
        " " +
        longitudeCardinal
      );
    },

    rpmReport(rpm) {
      console.log("RPM LAPORAN");
      console.log(rpm);
      console.log(rpm.id);
      console.log(this.nameThuraya);
      this.inputRPMID(rpm.id);
      this.inputSearchIOT(this.nameThuraya);
      this.$router.push("/iot");
    },

    openETA() {
      this.etaControl = !this.etaControl;
      console.log(this.$refs["map"]);
      let now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      $("#departure-sailink").val(now.toISOString().slice(0, 16));
      if (this.$refs["map"].mapObject._isFullscreen != true) {
        this.$refs["map"].mapObject.toggleFullscreen();
      } else {
        console.log("ETA ALREADY OPEN");
      }
    },

    startDraw() {
      this.drawon = !this.drawon;
      if (this.drawon == true && this.showRouteData != null) {
        this.clearMeasure();
      }
      this.$refs["polylineMeasure"].mapObject._toggleMeasure();
      console.log(this.$refs["polylineMeasure"].mapObject._arrPolylines);
    },

    clearMeasure() {
      this.$refs["polylineMeasure"].mapObject._clearAllMeasurements();
      this.etaMiles = 0;
      this.etaDuration = 0;
      this.etaArrival = "";
      this.showRouteData = null;
    },

    closeETA() {
      if (this.$refs["map"].mapObject._isFullscreen != true) {
        console.log("FULLSCREEN CLOSE");
      } else {
        this.$refs["map"].mapObject.toggleFullscreen();
      }
    },

    onCount() {
      var currentLine = this.$refs["polylineMeasure"].mapObject._currentLine;
      var coords = currentLine.circleCoords;
      var toolTipsArr = currentLine.tooltips;
      this.showRouteData = coords.map((item, index) =>
        Object.assign(item, { index })
      );
      this.brRouteData = toolTipsArr;
      console.log("BRROUTE DATA");
      console.log(this.brRouteData[1]._icon.childNodes[4].innerText);
      var miles = 0;
      coords.forEach((coor, i) => {
        console.log("lat = " + coor.lat);
        console.log("lng = " + coor.lng);
        this.totalDistance = toolTipsArr[i]._icon.childNodes[4].innerText;
        miles = parseFloat(toolTipsArr[i]._icon.childNodes[4].innerText);
      });

      this.etaMiles = miles;
      var duration_raw = miles / this.etaSpeed;
      var duration = duration_raw.toFixed(2);

      console.log("SPEED == " + this.speed);
      console.log(miles + " nmi");
      console.log("DURATION == " + duration + " hours");

      var departDateInput = $("#departure-sailink").val();
      console.log("DEPARTURE INPUT ===== " + departDateInput);

      // 2018-11-24 10:33:30:0
      var today = new Date(departDateInput);
      var seconds = Math.round(duration * 60 * 60);
      console.log("seconds == " + seconds);
      console.log(today.getSeconds());
      today.setSeconds(today.getSeconds() + seconds);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      var h = today.getHours();
      var i = today.getMinutes();

      if (h < 10) {
        h = "0" + h;
      }

      if (i < 10) {
        i = "0" + i;
      }

      today = dd + "/" + mm + "/" + yyyy + " " + h + ":" + i;
      console.log("arrival date " + today);
      this.etaDuration = duration;
      this.etaArrival = today;
    },

    countETA() {
      var duration_raw = this.etaMiles / this.etaSpeed;
      var duration = duration_raw.toFixed(2);

      console.log("SPEED == " + this.speed);
      console.log(this.etaMiles + " nmi");
      console.log("DURATION == " + duration + " hours");

      var departDateInput = $("#departure-sailink").val();
      console.log("DEPARTURE INPUT ===== " + departDateInput);

      // 2018-11-24 10:33:30:0
      var today = new Date(departDateInput);
      var seconds = Math.round(duration * 60 * 60);
      console.log("seconds == " + seconds);
      console.log(today.getSeconds());
      today.setSeconds(today.getSeconds() + seconds);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      var h = today.getHours();
      var i = today.getMinutes();

      if (h < 10) {
        h = "0" + h;
      }

      if (i < 10) {
        i = "0" + i;
      }

      today = dd + "/" + mm + "/" + yyyy + " " + h + ":" + i;
      console.log("arrival date " + today);
      this.etaDuration = duration;
      this.etaArrival = today;
    },

    handleToggle() {
      if (this.ex25) {
        console.log("FROM MARKER CHECKED");
        console.log(parseFloat(this.showmaptracking_thur.maptop.lat)),
          console.log(parseFloat(this.showmaptracking_thur.maptop.lon)),
          this.$refs["map"].mapObject.fire("click", {
            latlng: L.latLng([
              parseFloat(this.showmaptracking_thur.maptop.lat),
              parseFloat(this.showmaptracking_thur.maptop.lon),
            ]),
          });
      }
    },

    handleFinish() {
      console.log("ITS FINISH");
      $("#strDraw_btn").click();
    },

    async showweather(vid, msgid, type) {
      this.msg_id_after = msgid;
      this.weather_data = null;
      const data = {
        id: vid,
        msg_id: msgid,
        type: type,
      };
      const response = await axios.post("v1/navplus/weather/fetchRow", data, {
        headers: {
          Authorization: "Bearer" + localStorage.getItem("token"),
        },
      });
      console.log(response);
      this.weather_data = response.data.data;
    },

    showondate(item, range) {
      clearInterval(this.IntervalMoving);
      this.countLength=0;
      console.log('JALAN SAMPE DATE DI SHOW MAP')
      const data = {
        id: item,
        range: range,
        token: localStorage.getItem("token"),
      };

      this.showdateThuraya(data);
      var mother = this;
        var intervalSeconds = 0.5;
        this.fetchInterval = setInterval(function () {
          mother.initialdata_moving();
        }, intervalSeconds);
      
    },
  },

  computed: {
    ...mapGetters([
      "searchIDThuraya",
      "thuraya_executed",
      "showmapthuraya",
      "showmaptracking_thur",
      "showthurayaclick",
      "thurayadataTable",
      "vesselUsersThuraya",
      "nameThuraya",
      "clickdate",
    ]),
    mapConfig() {
      return {
        ...mapSettingsShow,
        center: this.mapCenter,
      };
    },

    mapCenter() {
      return {
        lat: parseFloat(this.showmapthuraya.maptop.lat),
        lng: parseFloat(this.showmapthuraya.maptop.lon),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.posisi {
  float: right;
  height: 450px;
}

.track_txt {
  font-size: 15px;
  margin-top: 17px;
  margin-right: 15px;
}

.flexposisi {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  padding: 25px;
}

.list-group {
  text-align: left;
  width: 500px;
}

ul {
  list-style-type: none;
}

.btnlinkstatus {
  background-color: #a0f59d;
  border-radius: 3px;
  border: 1px solid #033301;
  box-shadow: rgba(146, 241, 162, 0.7) 0 1px 0 0 inset;
  box-sizing: border-box;
  color: #033301;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, "Segoe UI", "Liberation Sans",
    sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.15385;
  margin: 0;
  outline: none;
  padding: 8px 0.8em;
  position: relative;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  white-space: nowrap;
}

.btnlinkstatus,
.btnlinkstatus {
  background-color: #a0f59d;
  color: #033301;
}

.btnlinkstatus {
  box-shadow: 0 0 0 4px rgba(4, 59, 104, 0.15);
}

.btnlinkstatus {
  background-color: #a0f59d;
  box-shadow: none;
  color: #033301;
}

.txt_showmap {
  color: #2c2c2c;
  margin-top: 15px;
}

.images_td {
  background-color: #e8ebef;
}

.fill-width {
  overflow-y: auto;
  height: 15rem;
  width: 100%;
  margin-top: 5px;
}

.mobile_showmap {
  display: none;
}

.desktop_showmap {
  display: block;
}

/* x-Small Mobile Devices */
@media (max-width: 280px) {
  .flexposisi {
    display: block;
  }

  .mobile_showmap {
    display: block;
  }

  .desktop_showmap {
    display: none;
  }
}

/* Small Mobile Devices */
@media (min-width: 280px) and (max-width: 319px) {
  .flexposisi {
    display: block;
  }

  .mobile_showmap {
    display: block;
  }

  .desktop_showmap {
    display: none;
  }
}

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  .flexposisi {
    display: block;
  }

  .mobile_showmap {
    display: block;
  }

  .desktop_showmap {
    display: none;
  }
}

/* iPads, Tablets */
@media (min-width: 481px) and (max-width: 768px) {
  .flexposisi {
    display: block;
  }

  .mobile_showmap {
    display: block;
  }

  .desktop_showmap {
    display: none;
  }
}

/* Small screens, laptops */
@media (min-width: 769px) and (max-width: 1024px) {
  .flexposisi {
    display: flex;
  }
  .datacard {
    width: 47%;
  }
  .mapcard {
    width: 52%;
  }

  .mobile_showmap {
    display: none;
  }

  .desktop_showmap {
    display: block;
  }
}

/* Desktops, large screens */
@media (min-width: 1025px) and (max-width: 1200px) {
  .flexposisi {
    display: flex;
  }

  .datacard {
    width: 42%;
  }
  .mapcard {
    width: 50%;
  }

  .mapcard {
    width: 35rem;
  }
  .mobile_showmap {
    display: none;
  }
}

/* Extra large screens / TV */
@media screen and (min-width: 1201px) {
  .flexposisi {
    display: flex;
  }

  .datacard {
    width: 40%;
  }
  .mapcard {
    width: 59%;
  }
  .mobile_showmap {
    display: none;
  }
}

.hideControl {
  opacity: 0;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: none;
  cursor: pointer;
}

.image tbody {
  display: flex;
  white-space: initial;
  flex-wrap: wrap;
  text-align: center;
  width: 100%;
  padding: 1em 1em 0.5em 0.5em;
}

.gpiostatus {
  display: flex;
}
.txtgpio {
  margin-top: 15px;
}
.devicestate {
  display: block;
}
.blink {
  animation: blinker 1s linear infinite;
}
</style>
